import React, {useEffect} from "react"
import SelectInput, {Option} from "./SelectInput";
import {usePrevious} from "../utils/HooksHelper";

interface Props {
    placeholder: string,
    label: string,
    id: string,
    hint: string,
    options: Array<any>,
    onSelectGroup: (indexes: any) => void,
    onTryingToRemoveFixedOption?: Function,
    value?: Array<Option>,

}

const formatOptionLabel = ({name, selectId}: any) => (
    <>
        {`${name} (${selectId})`}
    </>
);

const singleValue = ({data}: any) => {
    return (
        <span onClick={data.onClick}>
            {`${data.name}`}
        </span>
    )
};

export default (props: Props) => {

    // Props

    const {
        placeholder,
        label,
        id,
        hint,
        options,
        onSelectGroup,
        onTryingToRemoveFixedOption,
        value = []
    } = props;

    // Effects

    const prevGroupCount = usePrevious(value.length);

    useEffect(() => {
        if (value.length > prevGroupCount) {
            document.getElementsByClassName("selectInput__value-container")[0].scrollTop += 1000;
        }
    }, [value.length, prevGroupCount]);

    return (
        <SelectInput
            id={id}
            onTryingToRemoveFixedOption={onTryingToRemoveFixedOption}
            isMulti
            options={options}
            placeholder={placeholder}
            label={label}
            hint={hint}
            value={value}
            isSearchable
            formatOptionLabel={formatOptionLabel}
            onChange={onSelectGroup}
            SingleValue={singleValue}
        />
    );
}
